import React, { useEffect } from 'react'

export default function MetaTags({ title, description }) {
  useEffect(() => {
    // Update document title
    document.title = title ? title : 'Elses skrub og skur'

    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]')
    if (!metaDescription) {
      metaDescription = document.createElement('meta')
      metaDescription.setAttribute('name', 'description')
      document.head.appendChild(metaDescription)
    }
    metaDescription.setAttribute(
      'content',
      description ||
        'Elses skrub og skur tilbyder grundig og pålidelig privat- og erhvervsrengøring i Skjern og omegn. Kontakt mig for en uforpligtende snak.'
    )
  }, [title, description])

  return null
}
